import axios from 'axios'
import { useEffect, useRef } from 'react'

export const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

const debounce = (callback, wait) => {
  let timeoutId = null
  return (...args) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => {
      callback(...args)
    }, wait)
  }
}

const deleteAuthCookies = () => {
  return ['access_token', 'refresh_token'].forEach((token) =>
    deleteCookie(token)
  )
}

export const deleteCookie = (name, path, domain) => {
  if (getCookie(name)) {
    document.cookie =
      name +
      '=' +
      (path ? ';path=' + path : '') +
      (domain ? ';domain=' + domain : '') +
      ';expires=Thu, 01 Jan 1970 00:00:01 GMT'
  }
}

class ApiClient {
  constructor() {
    this.axios = axios.create()
    this.isRefreshing = false
    this.requests = []

    this.user = null

    this.axios.interceptors.request.use((config) => {
      const token = `Bearer ${getCookie('access_token')}`
      config.headers.Authorization = token

      return config
    })

    this.axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error.request.status === 401) {
          return this.handleUnauthorized(error)
        } else if (error.request.status === 402) {
          window.location.replace('/billing?unpaid=true')
        } else {
          return Promise.reject(error)
        }
      }
    )
  }

  axios = this.axios

  handleUnauthorized(error) {
    // if (!this.user) return this.logout()

    const config = error.config

    if (!this.isRefreshing) {
      this.isRefreshing = true

      return this.refreshToken()
        .then((res) => {
          this.requests.forEach((cb) => cb())
          this.requests = []

          const newConfig = this.getNewConfig(config)

          return axios(newConfig)
        })
        .catch(() => {
          return this.logout()
        })
        .finally(() => {
          this.isRefreshing = false
        })
    } else {
      return new Promise((resolve) => {
        this.requests.push(() => {
          resolve(axios(this.getNewConfig(config)))
        })
      })
    }
  }

  getNewConfig(config) {
    if (config.url.indexOf('?') > -1) {
      config.url = config.url + '&n=' + new Date().getTime()
    } else {
      config.url = config.url + '?n=' + new Date().getTime()
    }
    config.headers['Authorization'] = `Bearer ${getCookie('access_token')}`

    return config
  }

  logout() {
    this.isRefreshing = false
    this.requests = []
    this.user = null
    deleteAuthCookies()
    window.location.replace('/login')
  }

  refreshToken() {
    return axios.post('/api/auth/refresh', {
      // user: {
      //   id: this.user.id,
      //   companyId: this.user.companyId,
      // },
      refreshToken: getCookie('refresh_token'),
    })
  }

  setUser = (user) => (this.user = user)

  deleteAuthCookies = deleteAuthCookies
}

const apiClient = new ApiClient()

const authedAxios = apiClient.axios

const sleep = (ms) => new Promise((res) => setTimeout(res, ms))

function useTraceUpdate(props) {
  const prev = useRef(props)
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v]
      }
      return ps
    }, {})
    if (Object.keys(changedProps).length > 0) {
      console.log('Changed props:', changedProps)
    }
    prev.current = props
  })
}

const print = (divId) => {
  // const elem = document.getElementById(divId)

  var mywindow = window.open('', 'PRINT', 'height=800,width=1200')

  mywindow.document.write('<html><head><title>' + document.title + '</title>')
  mywindow.document.write('</head><body >')
  mywindow.document.write('<h1>' + document.title + '</h1>')
  mywindow.document.write(document.getElementById(divId).innerHTML)
  mywindow.document.write('</body></html>')

  mywindow.document.close() // necessary for IE >= 10
  mywindow.focus() // necessary for IE >= 10*/

  mywindow.print()
  mywindow.close()

  return true
}

export {
  authedAxios,
  debounce,
  apiClient,
  deleteAuthCookies,
  sleep,
  useTraceUpdate,
  print,
}
